import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { OtpStatus } from '../../../../core/api/models';
import { UpdateOtpStatusCommand } from '../../../../core/api/models/update-otp-status-command';
import { OtpsService } from '../../../../core/api/services/otps.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { ModalTitleComponent } from "../../../../shared/global/modal-title/modal-title.component";

@Component({
    selector: 'app-change-otp-status-form',
    templateUrl: './change-otp-status-form.component.html',
    imports: [BaseFormModule, ModalTitleComponent]
})
export class ChangeOtpStatusFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: UpdateOtpStatusCommand = {};
  get OtpStatusType() {
    return OtpStatus;
  }

  //#endregion

  constructor(
    protected currentService: OtpsService,
    private dialogRef: MatDialogRef<ChangeOtpStatusFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();
    this.formPageConfig.title = data?.title;
    this.formPageConfig.isEditMode = data?.isEdit;
    this.pageVocabs = data?.pageVocab;
    if (data.model) this.model = data.model;
  }

  ngOnInit() {
    this.initForm();
  }

  //#region init methods

  initForm(): void {
    this.form = new FormGroup({
      otpStatus: new FormControl('', Validators.required),
      priority: new FormControl('', Validators.required),
    });
  }

  //#endregion

  //#region api

  //Update
  baseUpdateApi(model: UpdateOtpStatusCommand): void {
    this.currentService
      .otpsUpdateStatusPut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (this.loading) return;
      if (!this.isValidForm(this.form, this.tagName)) return;

      try {
        this.baseUpdateApi(this.model);
      } catch (error) {
        ConsoleService.error('error', error);
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  onSuccess() {
    this.dialogRef.close(true);
    this.unSubs();
  }
}
